import React from 'react'
import { useTranslation } from 'react-i18next'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

const ShippingTable = props => {
	const { t } = useTranslation();
	const { data } = props
	return (
		<Table>
            <TableHead>
                <TableRow>
					<TableCell style={{paddingLeft: '30px'}}>{t('picker_name')}</TableCell>
                    <TableCell colSpan={2}>{t('picker_tel')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell style={{paddingLeft: '30px'}}>{data.get('shippingName')}</TableCell>
                    <TableCell colSpan={2}>{data.get('shippingPhone')}</TableCell>
                </TableRow>
            </TableBody>
            
            <TableHead>
                <TableRow>
					<TableCell style={{paddingLeft: '30px'}}>{t('shipping_type')}</TableCell>
                    <TableCell>{t('shipping_address')}</TableCell>
                    <TableCell>{t('pickup_date_time')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell style={{paddingLeft: '30px'}}>{data.get('shippingType')}</TableCell>
                    <TableCell>{data.get('address')}</TableCell>
                    <TableCell>{data.get('shippingTime')}</TableCell>
                </TableRow>
            </TableBody>
            
            <TableHead>
                <TableRow>
					<TableCell colSpan={3} style={{paddingLeft: '30px'}}>{t('remark')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell colSpan={3} style={{paddingLeft: '30px'}}>
                        {data.get('message')}
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
	)
}

export default ShippingTable
